// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ecFF","field":"styles_field__35mGP","fieldCol":"styles_fieldCol__1tS3s","diffCol":"styles_diffCol__2Q5hy","diff":"styles_diff__n6mKK"};